// -- REPORTS -- // - converted to lazy loading

const mainReport = () => import('@/pages/reports/main.vue')

const overview = () => import('@/pages/reports/overview.vue')
const sales = () => import('@/pages/reports/sales.vue')
const purchases = () => import('@/pages/reports/purchases.vue')
const lockers = () => import('@/pages/reports/lockers.vue')
const stocks = () => import('@/pages/reports/stocks.vue')
const employee = () => import('@/pages/reports/employee.vue')
const partner = () => import('@/pages/reports/partner.vue')
const discount = () => import('@/pages/reports/discount.vue')
const pointOfSale = () => import('@/pages/reports/pointOfSale.vue')
// import shipping from '@/pages/reports/shipping.vue'
const pointOfSalesOverview = () => import('@/pages/reports/pointOfSales/overview.vue')
const pointOfSalesSessionsReport = () => import('@/pages/reports/pointOfSales/sessions.vue')
const checks = () => import('@/pages/reports/checks.vue')
const manufacturing = () => import('@/pages/reports/manufacturing.vue')
//customers reports - converted to lazy loading
const customersTotalAccounts = () => import('@/pages/reports/customers/totalAccounts.vue')
const customersBalance = () => import('@/pages/reports/customers/balance.vue')
const customersGuide = () => import('@/pages/reports/customers/guide.vue')
const customersInactive = () => import('@/pages/reports/customers/inactive.vue')
const customersActive = () => import('@/pages/reports/customers/active.vue')
const customerTraffic = () => import('@/pages/reports/customers/customerTraffic.vue')
const salesCollection = () => import('@/pages/reports/customers/salesCollection.vue')

//suppliers reports - converted to lazy loading
const suppliersTotalAccounts = () => import('@/pages/reports/suppliers/totalAccounts.vue')
const suppliersBalance = () => import('@/pages/reports/suppliers/balance.vue')
const suppliersGuide = () => import('@/pages/reports/suppliers/guide.vue')
const suppliersInactive = () => import('@/pages/reports/suppliers/inactive.vue')
const supplierMovement = () => import('@/pages/reports/suppliers/supplierMovement.vue')
const purchasingCollecting = () => import('@/pages/reports/suppliers/purchasingCollecting.vue')

//employees reports - converted to lazy loading
const employeesTotalAccounts = () => import('@/pages/reports/employees/totalAccounts.vue')
const employeesBalance = () => import('@/pages/reports/employees/balance.vue')
const employeesGuide = () => import('@/pages/reports/employees/guide.vue')

//employeesOperations reports - converted to lazy loading
const employeesOperationsDeductions = () =>
  import('@/pages/reports/employeesOperations/employeesDeductions.vue')
const employeesOperationsIncentives = () =>
  import('@/pages/reports/employeesOperations/employeesIncentives.vue')
const employeesOperationsSalaries = () =>
  import('@/pages/reports/employeesOperations/employeesSalaries.vue')
const employeesOperationsWithdrawals = () =>
  import('@/pages/reports/employeesOperations/employeesWithdrawals.vue')
const employeesTraffic = () => import('@/pages/reports/employees/employeesTraffic.vue')

//safes reports - converted to lazy loading
const safesAccounts = () => import('@/pages/reports/safes/accounts.vue')
const safersBalance = () => import('@/pages/reports/safes/balance.vue')
const safesMove = () => import('@/pages/reports/safes/safesMove.vue')

//stores reports - converted to lazy loading
const warehouseInventory = () => import('@/pages/reports/stores/warehouseInventory.vue')
const ProductsValue = () => import('@/pages/reports/stores/ProductsValue.vue')
const productAlerts = () => import('@/pages/reports/stores/productAlerts.vue')
const validityAlerts = () => import('@/pages/reports/stores/validityAlerts.vue')

//sales reports - converted to lazy loading
const salesByInvoice = () => import('@/pages/reports/sales/invoice.vue')
const salesByItem = () => import('@/pages/reports/sales/item.vue')
const salesByProductByBranch = () => import('@/pages/reports/sales/productBranch.vue')
const salesBySection = () => import('@/pages/reports/sales/section.vue')
const salesByBranch = () => import('@/pages/reports/sales/branch.vue')
const salesByUser = () => import('@/pages/reports/sales/user.vue')
const salesByHours = () => import('@/pages/reports/sales/hours.vue')
const salesByCustomer = () => import('@/pages/reports/sales/customer.vue')
const customerSalesPrices = () => import('@/pages/reports/sales/customerSalesPrices')
const customersRegister = () => import('@/pages/reports/customers/customersRegister.vue')

//subscriptionsOperations reports
// import shippingOperationsByInvoice from '@/pages/reports/shippingOperations/shippingOperationsByInvoice.vue'

//purchases reports - converted to lazy loading
const purchasesByBill = () => import('@/pages/reports/purchases/bill.vue')
const purchasesByItem = () => import('@/pages/reports/purchases/item.vue')

//storesdeposits reports - converted to lazy loading
const storesDepositsByInvoice = () => import('@/pages/reports/storesDeposits/invoice.vue')
const storesDepositsByItem = () => import('@/pages/reports/storesDeposits/item.vue')

//storeswithdrawals reports - converted to lazy loading
const storesWithdrawalsByBill = () => import('@/pages/reports/storesWithdrawals/bill.vue')
const storesWithdrawalsByItem = () => import('@/pages/reports/storesWithdrawals/item.vue')

//storestransfers reports - converted to lazy loading
const storesTransfersByInvoice = () => import('@/pages/reports/storesTransfers/invoice.vue')
const storesTransfersByItem = () => import('@/pages/reports/storesTransfers/item.vue')

//salesReturns reports - converted to lazy loading
const salesReturnsByInvoice = () => import('@/pages/reports/salesReturns/invoice.vue')
const salesReturnsByItem = () => import('@/pages/reports/salesReturns/item.vue')

//purchasesReturns reports - converted to lazy loading
const purchasesReturnsByBill = () => import('@/pages/reports/purchasesReturns/bill.vue')
const purchasesReturnsByItem = () => import('@/pages/reports/purchasesReturns/item.vue')
const productPurchasesRegister = () =>
  import('@/pages/reports/purchases/productPurchasesRegister.vue')

// //salesOrders reports
// import salesOrdersByInvoice from '@/pages/reports/salesOrders/invoice.vue'
// import salesOrdersByItem from '@/pages/reports/salesOrders/item.vue'

// //purchasesOrders reports
// import purchasesOrdersByBill from '@/pages/reports/purchasesOrders/bill.vue'
// import purchasesOrdersByItem from '@/pages/reports/purchasesOrders/item.vue'

//payments reports - converted to lazy loading
const paymentHistory = () => import('@/pages/reports/payments/paymentHistory.vue')

const purchasePaymentHistory = () => import('@/pages/reports/payments/purchasePaymentHistory.vue')

const safeDepositHistory = () => import('@/pages/reports/safesDeposits/safeDepositHistory.vue')
const safeWithdrawalHistory = () =>
  import('@/pages/reports/safesWithdrawals/safeWithdrawalHistory.vue')
const safeTransferHistory = () => import('@/pages/reports/safesTransfers/safeTransferHistory.vue')

//discounts reports - converted to lazy loading
const discountsHistory = () => import('@/pages/reports/discounts/discountsHistory.vue')
const purchaseDiscountsHistory = () =>
  import('@/pages/reports/discounts/purchaseDiscountsHistory.vue')

//expenses reports - converted to lazy loading
const expenseHistory = () => import('@/pages/reports/expenses/history.vue')
const expenseByCategory = () => import('@/pages/reports/expenses/category.vue')

//incomes reports - converted to lazy loading
const incomeHistory = () => import('@/pages/reports/incomes/history.vue')
const incomeByCategory = () => import('@/pages/reports/incomes/category.vue')

// productDetails reports - converted to lazy loading
const productDetailsAccounts = () => import('@/pages/reports/products/detailsAccounts.vue')
const productAverageCost = () => import('@/pages/reports/products/averageCost.vue')

//inactiveProducts - converted to lazy loading
const inactiveProducts = () => import('@/pages/reports/products/inactiveProducts.vue')

//partners reports - converted to lazy loading
const partnersTotalAccounts = () => import('@/pages/reports/partners/totalAccounts.vue')
const partnersBalance = () => import('@/pages/reports/partners/balance.vue')
const partnersGuide = () => import('@/pages/reports/partners/guide.vue')
const partnerMovement = () => import('@/pages/reports/partners/partnerMovement.vue')
const partnerDepositsHistory = () =>
  import('@/pages/reports/partnersPayments/partnerDepositsHistory.vue')
const partnerWithdrawalsHistory = () =>
  import('@/pages/reports/partnersPayments/partnerWithdrawalsHistory.vue')

//cheques reports - converted to lazy loading
const chequesHistory = () => import('@/pages/reports/cheques/chequesHistory.vue')
const purchaseChequesHistory = () => import('@/pages/reports/cheques/purchaseChequesHistory.vue')
// import taxHistory from '@/pages/reports/taxes/taxHistory.vue'

// manufacturing reports - converted to lazy loading
const manufacturingDepositsByItem = () => import('@/pages/reports/manufacturing/depositsByItem.vue')
const manufacturingWithdrawalsByItem = () =>
  import('@/pages/reports/manufacturing/withdrawalsByItem.vue')
const manufacturingModelsUsedCount = () => import('@/pages/reports/manufacturing/modelsUsedCount')

const manufacturingModelsByMaterial = () =>
  import('@/pages/reports/manufacturing/modelsByMaterial.vue')
const modelsCreatingProduct = () =>
  import('@/pages/reports/manufacturing/modelsCreatingProduct.vue')
const Taxes = () => import('@/pages/reports/taxes.vue')
const TaxDeclaration = () => import('@/pages/reports/taxes/taxDeclaration.vue')
const discountCodesReports = () => import('@/pages/reports/discountCodes.vue')
const discountCodesReport = () => import('@/pages/reports/discountCodes/discountCodes.vue')

// loyal points reports - converted to lazy loading
const LoyalPointsReports = () => import('@/pages/reports/loyalPoints.vue')
const LoyalPointsReport = () => import('@/pages/reports/loyalPoints/loyalPoints.vue')
const LoyalPointsCreditsRecharge = () => import('@/pages/reports/loyalPoints/creditsRecharge.vue')
const LoyalPointsCreditsConsumptions = () =>
  import('@/pages/reports/loyalPoints/creditsConsumptions.vue')
const ShippingOperations = () => import('@/pages/reports/shipping')
const ShippingOperationsByPointOfSale = () =>
  import('@/pages/reports/shippingOperations/pointOfSale.vue')
const ShippingOperationsByDelivery = () => import('@/pages/reports/shippingOperations/delivery.vue')
const ShippingOperationsByInvoice = () =>
  import('@/pages/reports/shippingOperations/shippingOperationsByInvoice.vue')
const CallCenterReports = () => import('@/pages/reports/callCenterReports.vue')
const CallCenterDevice = () => import('@/pages/reports/callCenter/device.vue')
const CallCenterOrder = () => import('@/pages/reports/callCenter/order.vue')
const CallCenterUser = () => import('@/pages/reports/callCenter/user.vue')
const BestSellingSections = () => import('@/pages/reports/sales/sections.vue')

const routes = [
  { path: 'overview', name: 'overview', component: overview },
  { path: 'sales', name: 'sales', component: sales },
  { path: 'purchases', name: 'purchases', component: purchases },
  { path: 'lockers', name: 'lockers', component: lockers },
  { path: 'stocks', name: 'stocks', component: stocks },
  { path: 'employee', name: 'employee', component: employee },
  { path: 'partner', name: 'partner', component: partner },
  { path: 'checks', name: 'checks', component: checks },
  { path: 'manufacturing', name: 'manufacturing', component: manufacturing },

  { path: 'discount', name: 'discount', component: discount },
  { path: 'pointOfSale', name: 'pointOfSale', component: pointOfSale },
  // { path: 'shipping', name: 'shipping', component: shipping },

  // reports router
  { path: 'mainReport', name: 'mainReport', component: mainReport },
  {
    path: 'pointOfSalesOverview',
    name: 'pointOfSalesOverview',
    component: pointOfSalesOverview
  },
  {
    path: 'pointOfSalesSessionsReport',
    name: 'pointOfSalesSessions',
    component: pointOfSalesSessionsReport
  },

  {
    path: 'customersTotalAccounts',
    name: 'customersTotalAccounts',
    component: customersTotalAccounts
  },

  {
    path: 'customersBalance',
    name: 'customersBalance',
    component: customersBalance
  },
  {
    path: 'customersGuide',
    name: 'customersGuide',
    component: customersGuide
  },
  {
    path: 'customersInactive',
    name: 'customersInactive',
    component: customersInactive
  },
  {
    path: 'customersActive',
    name: 'customersActive',
    component: customersActive
  },
  {
    path: 'customerTraffic',
    name: 'customerTraffic',
    component: customerTraffic
  },
  {
    path: 'salesCollection',
    name: 'salesCollection',
    component: salesCollection
  },

  {
    path: 'suppliersTotalAccounts',
    name: 'suppliersTotalAccounts',
    component: suppliersTotalAccounts
  },

  {
    path: 'suppliersBalance',
    name: 'suppliersBalance',
    component: suppliersBalance
  },
  {
    path: 'suppliersGuide',
    name: 'suppliersGuide',
    component: suppliersGuide
  },
  {
    path: 'suppliersInactive',
    name: 'suppliersInactive',
    component: suppliersInactive
  },
  {
    path: 'supplierMovement',
    name: 'supplierMovement',
    component: supplierMovement
  },
  {
    path: 'purchasingCollecting',
    name: 'purchasingCollecting',
    component: purchasingCollecting
  },
  // {
  //   path: 'totalAccounts',
  //   name: 'totalAccounts',
  //   component: totalAccounts
  // },

  {
    path: 'employeesTotalAccounts',
    name: 'employeesTotalAccounts',
    component: employeesTotalAccounts
  },
  {
    path: 'employeesBalance',
    name: 'employeesBalance',
    component: employeesBalance
  },
  {
    path: 'employeesGuide',
    name: 'employeesGuide',
    component: employeesGuide
  },
  {
    path: 'employeesTraffic',
    name: 'employeesTraffic',
    component: employeesTraffic
  },
  {
    path: 'employeesOperationsDeductions',
    name: 'employeesOperationsDeductions',
    component: employeesOperationsDeductions
  },
  {
    path: 'employeesOperationsIncentives',
    name: 'employeesOperationsIncentives',
    component: employeesOperationsIncentives
  },
  {
    path: 'employeesOperationsSalaries',
    name: 'employeesOperationsSalaries',
    component: employeesOperationsSalaries
  },
  {
    path: 'employeesOperationsWithdrawals',
    name: 'employeesOperationsWithdrawals',
    component: employeesOperationsWithdrawals
  },
  {
    path: 'safesAccounts',
    name: 'safesAccounts',
    component: safesAccounts
  },
  {
    path: 'safersBalance',
    name: 'safersBalance',
    component: safersBalance
  },
  {
    path: 'safesMove',
    name: 'safesMove',
    component: safesMove
  },

  {
    path: 'warehouseInventory',
    name: 'warehouseInventory',
    component: warehouseInventory
  },
  {
    path: 'ProductsValue',
    name: 'ProductsValue',
    component: ProductsValue
  },
  {
    path: 'productAlerts',
    name: 'productAlerts',
    component: productAlerts
  },
  {
    path: 'validityAlerts',
    name: 'validityAlerts',
    component: validityAlerts
  },

  {
    path: 'salesByInvoice',
    name: 'salesByInvoice',
    component: salesByInvoice
  },

  { path: 'salesByItem', name: 'salesByItem', component: salesByItem },
  {
    path: 'salesByProductByBranch',
    name: 'salesByProductByBranch',
    component: salesByProductByBranch
  },

  {
    path: 'salesByBranch',
    name: 'salesByBranch',
    component: salesByBranch
  },
  { path: 'salesBySection', name: 'salesBySection', component: salesBySection },

  {
    path: 'salesByUser',
    name: 'salesByUser',
    component: salesByUser
  },
  {
    path: 'salesByCustomer',
    name: 'salesByCustomer',
    component: salesByCustomer
  },
  {
    path: 'salesByHours',
    name: 'salesByHours',
    component: salesByHours
  },
  {
    path: 'customerSalesPrices',
    name: 'customerSalesPrices',
    component: customerSalesPrices
  },

  {
    path: 'customersRegister',
    name: 'customersRegister',
    component: customersRegister
  },

  {
    path: 'purchasesByBill',
    name: 'purchasesByBill',
    component: purchasesByBill
  },
  {
    path: 'purchasesByItem',
    name: 'purchasesByItem',
    component: purchasesByItem
  },

  // salesReturns routes
  {
    path: 'salesReturnsByInvoice',
    name: 'salesReturnsByInvoice',
    component: salesReturnsByInvoice
  },
  {
    path: 'salesReturnsByItem',
    name: 'salesReturnsByItem',
    component: salesReturnsByItem
  },

  // purchasesReturns routes
  {
    path: 'purchasesReturnsByBill',
    name: 'purchasesReturnsByBill',
    component: purchasesReturnsByBill
  },
  {
    path: 'purchasesReturnsByItem',
    name: 'purchasesReturnsByItem',
    component: purchasesReturnsByItem
  },
  {
    path: 'productPurchasesRegister',
    name: 'productPurchasesRegister',
    component: productPurchasesRegister
  },

  // // salesOrders routes
  // {
  //   path: 'salesOrdersByInvoice',
  //   name: 'salesOrdersByInvoice',
  //   component: salesOrdersByInvoice
  // },
  // {
  //   path: 'salesOrdersByItem',
  //   name: 'salesOrdersByItem',
  //   component: salesOrdersByItem
  // },

  {
    path: 'storesDepositsByInvoice',
    name: 'storesDepositsByInvoice',
    component: storesDepositsByInvoice
  },
  {
    path: 'storesDepositsByItem',
    name: 'storesDepositsByItem',
    component: storesDepositsByItem
  },

  {
    path: 'storesWithdrawalsByBill',
    name: 'storesWithdrawalsByBill',
    component: storesWithdrawalsByBill
  },
  {
    path: 'storesWithdrawalsByItem',
    name: 'storesWithdrawalsByItem',
    component: storesWithdrawalsByItem
  },

  {
    path: 'storesTransfersByInvoice',
    name: 'storesTransfersByInvoice',
    component: storesTransfersByInvoice
  },
  {
    path: 'storesTransfersByItem',
    name: 'storesTransfersByItem',
    component: storesTransfersByItem
  },

  // purchasesOrders routes
  // {
  //   path: 'purchasesOrdersByBill',
  //   name: 'purchasesOrdersByBill',
  //   component: purchasesOrdersByBill
  // },
  // {
  //   path: 'purchasesOrdersByItem',
  //   name: 'purchasesOrdersByItem',
  //   component: purchasesOrdersByItem
  // },

  {
    path: 'paymentHistory',
    name: 'paymentHistory',
    component: paymentHistory
  },
  {
    path: 'purchasePaymentHistory',
    name: 'purchasePaymentHistory',
    component: purchasePaymentHistory
  },

  {
    path: 'safeDepositHistory',
    name: 'safeDepositHistory',
    component: safeDepositHistory
  },
  {
    path: 'safeWithdrawalHistory',
    name: 'safeWithdrawalHistory',
    component: safeWithdrawalHistory
  },
  {
    path: 'safeTransferHistory',
    name: 'safeTransferHistory',
    component: safeTransferHistory
  },
  // cheques routes
  {
    path: 'chequesHistory',
    name: 'chequesHistory',
    component: chequesHistory
  },
  {
    path: 'purchaseChequesHistory',
    name: 'purchaseChequesHistory',
    component: purchaseChequesHistory
  },

  // discounts routes
  {
    path: 'discountsHistory',
    name: 'discountsHistory',
    component: discountsHistory
  },
  {
    path: 'purchaseDiscountsHistory',
    name: 'purchaseDiscountsHistory',
    component: purchaseDiscountsHistory
  },
  {
    path: 'expenseHistory',
    name: 'expenseHistory',
    component: expenseHistory
  },
  {
    path: 'expenseByCategory',
    name: 'expenseByCategory',
    component: expenseByCategory
  },

  {
    path: 'incomeHistory',
    name: 'incomeHistory',
    component: incomeHistory
  },
  {
    path: 'incomeByCategory',
    name: 'incomeByCategory',
    component: incomeByCategory
  },

  {
    path: 'productDetailsAccounts',
    name: 'productDetailsAccounts',
    component: productDetailsAccounts
  },
  {
    path: 'productAverageCost',
    name: 'productAverageCost',
    component: productAverageCost
  },
  {
    path: 'inactiveProducts',
    name: 'inactiveProducts',
    component: inactiveProducts
  },

  // partners reports
  {
    path: 'partnersTotalAccounts',
    name: 'partnersTotalAccounts',
    component: partnersTotalAccounts
  },

  {
    path: 'partnersBalance',
    name: 'partnersBalance',
    component: partnersBalance
  },
  {
    path: 'partnersGuide',
    name: 'partnersGuide',
    component: partnersGuide
  },
  {
    path: 'partnerMovement',
    name: 'partnerMovement',
    component: partnerMovement
  },

  {
    path: 'partnerDepositsHistory',
    name: 'partnerDepositsHistory',
    component: partnerDepositsHistory
  },

  {
    path: 'partnerWithdrawalsHistory',
    name: 'partnerWithdrawalsHistory',
    component: partnerWithdrawalsHistory
  },
  // {
  //   path: 'taxes/taxesHistory',
  //   name: 'taxesHistory',
  //   component: taxHistory
  // },

  // Manufacturing reports
  {
    path: 'manufacturingDepositsByItem',
    name: 'manufacturingDepositsByItem',
    component: manufacturingDepositsByItem
  },
  {
    path: 'manufacturingWithdrawalsByItem',
    name: 'manufacturingWithdrawalsByItem',
    component: manufacturingWithdrawalsByItem
  },
  {
    path: 'manufacturingModelsByMaterial',
    name: 'manufacturingModelsByMaterial',
    component: manufacturingModelsByMaterial
  },
  {
    path: 'modelsCreatingProduct',
    name: 'modelsCreatingProduct',
    component: modelsCreatingProduct
  },
  {
    path: 'manufacturingModelsUsedCount',
    name: 'manufacturingModelsUsedCount',
    component: manufacturingModelsUsedCount
  },
  {
    path: 'taxesReports',
    name: 'taxesReports',
    component: Taxes
  },
  {
    path: 'taxDeclaration',
    name: 'taxDeclaration',
    component: TaxDeclaration
  },
  {
    path: 'loyalPointsReports',
    name: 'loyalPointsReports',
    component: LoyalPointsReports
  },
  {
    path: 'loyalPointsReport',
    name: 'loyalPointsReport',
    component: LoyalPointsReport
  },
  {
    path: 'creditsRechargeReports',
    name: 'creditsRechargeReports',
    component: LoyalPointsCreditsRecharge
  },
  {
    path: 'creditsConsumptionsReports',
    name: 'creditsConsumptionsReports',
    component: LoyalPointsCreditsConsumptions
  },
  {
    path: 'discountCodesReports',
    name: 'discountCodesReports',
    component: discountCodesReports
  },
  {
    path: 'discountCodesReport',
    name: 'discountCodesReport',
    component: discountCodesReport
  },
  {
    path: 'shipping',
    name: 'shipping',
    component: ShippingOperations
  },
  {
    path: 'shippingOperationsByPointOfSale',
    name: 'shippingOperationsByPointOfSale',
    component: ShippingOperationsByPointOfSale
  },
  {
    path: 'shippingOperationsByDelivery',
    name: 'shippingOperationsByDelivery',
    component: ShippingOperationsByDelivery
  },
  {
    path: 'shippingOperationsByInvoice',
    name: 'shippingOperationsByInvoice',
    component: ShippingOperationsByInvoice
  },
  {
    path: 'callCenterReports',
    name: 'callCenterReports',
    component: CallCenterReports
  },
  {
    path: 'callCenterDevice',
    name: 'callCenterDevice',
    component: CallCenterDevice
  },
  {
    path: 'callCenterOrder',
    name: 'callCenterOrder',
    component: CallCenterOrder
  },
  {
    path: 'callCenterUser',
    name: 'callCenterUser',
    component: CallCenterUser
  },
  {
    path: 'bestSellingSections',
    name: 'bestSellingSections',
    component: BestSellingSections
  }
]

export default routes
